export const logoutUser = () => {
  sessionStorage.removeItem("athenasToken");
  alert("Session is not valid");
  window.location.reload();
}